import { DateTimeService } from '@/base/domains';
import { LocalDateTime } from '@/base/types';
import { localDateTimeNow } from '@/utils/DateUtils';

export class InMemoryDateTimeService implements DateTimeService {
  strictLocalDateTimeNow(): Promise<LocalDateTime> {
    return Promise.resolve(localDateTimeNow());
  }
}
